<div class="saas-page">

  <!-- HEADER -->
  <div class="saas-header">
    <div>
      <h1 class="saas-title">
        Channel Mapping
      </h1>
      <p class="saas-subtitle">
        Link your Twilio / WhatsApp numbers to specific AI conversation flows.
      </p>
    </div>

    <div class="saas-actions" *ngIf="channels.length > 0">
      <div class="flex items-center gap-3">
        <span *ngIf="maxChannelsReached" class="pro-hint premium-pill">
          <i class="pi pi-crown"></i>
          Pro feature
        </span>
        <p-button
          label="Connect More Number"
          size="small"
          [disabled]="maxChannelsReached"
          (click)="openAddMapping(null)" class="shadow-sm">
        </p-button>
      </div>
    </div>
  </div>

  <div class="flex w-full mb-6" *ngIf="channels.length > 0">
    <div class="flex items-center gap-2 ml-auto">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText [(ngModel)]="searchTerm" placeholder="Search channels..." class="w-64" />
      </span>
    </div>
  </div>

  <div class="channel-guidance" *ngIf="!loading && channels.length === 0">
    <div class="guidance-card">
      <div class="guidance-copy">
        <h3>What you can do here</h3>
        <p>Connect your WhatsApp or SMS numbers and map them to the right automation workflows.</p>
      </div>
      <ul class="guidance-list">
        <li>Link phone numbers to AI workflows</li>
        <li>Manage status and routing</li>
        <li>See mapped workflows per channel</li>
        <li>Add new mappings as you scale</li>
      </ul>
      <button pButton label="Connect your first number" icon="pi pi-plus" class="p-button-sm p-button-outlined guidance-action" (click)="openAddMapping(null)"></button>
    </div>
  </div>

  <!-- TABLE -->
  <div class="saas-table-card">

    <p-table
      [value]="filteredChannels"
      [loading]="loading"
      [rows]="10"
      [paginator]="true"
      styleClass="p-datatable-sm saas-table">

      <!-- HEADER -->
      <ng-template pTemplate="header">
        <tr>
          <th>
            <button class="sort-header" (click)="setSort('senderIdentifier')">
              Phone Number
              <i class="pi" [ngClass]="getSortIcon('senderIdentifier')"></i>
            </button>
          </th>
          <th>
            <button class="sort-header" (click)="setSort('status')">
              Status
              <i class="pi" [ngClass]="getSortIcon('status')"></i>
            </button>
          </th>
          <th>Quality</th>
          <th>
            <button class="sort-header" (click)="setSort('workflows')">
              Workflows
              <i class="pi" [ngClass]="getSortIcon('workflows')"></i>
            </button>
          </th>
          <th class="text-right pr-6">Actions</th>
        </tr>
      </ng-template>

      <!-- BODY -->
      <ng-template pTemplate="body" let-ch>
        <tr>

          <!-- PHONE -->
          <td class="font-semibold text-slate-700">
            {{ ch.senderIdentifier }}
          </td>

          <!-- STATUS -->
          <td>
            <p-tag
              [value]="ch.status"
              severity="success">
            </p-tag>
          </td>

          <!-- QUALITY (live from Meta) -->
          <td>
            <p-tag *ngIf="numberQuality[ch.senderIdentifier] as q"
                   [value]="qualityLabel(q)" [severity]="qualitySeverity(q)"
                   pTooltip="WhatsApp number quality, live from Meta" tooltipPosition="top"></p-tag>
            <span *ngIf="!numberQuality[ch.senderIdentifier]" class="text-xs text-slate-400">—</span>
          </td>

          <!-- WORKFLOWS -->
          <td>
            <div class="flex flex-wrap gap-2">

              <p-chip
                *ngFor="let wf of ch.workflows"
                [label]="wf.workflowName"
                removable="true"
                (onRemove)="removeMapping(ch, wf)">
              </p-chip>

              <span
                *ngIf="!ch.workflows?.length"
                class="text-xs text-slate-400">
                No workflows mapped
              </span>

            </div>
          </td>

          <!-- ACTIONS -->
          <td class="text-right pr-6">
            <p-button
              icon="pi pi-plus"
              size="small"
              [text]="true"
              (click)="openAddMapping(ch)">
            </p-button>
          </td>

        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center py-12 text-slate-400">
            <i class="pi pi-phone text-3xl mb-2"></i>
            <p>No channels connected. Connect your first number.</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- ADD MAPPING MODAL -->
  <p-dialog
    header="Add Workflow Mapping"
    [(visible)]="showMappingDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '640px' }"
    styleClass="mapping-dialog"
  [contentStyle]="{ 'max-height': '60vh', 'overflow': 'auto' }">

    <div class="mapping-form-body">
      <div class="mapping-field">
        <label class="mapping-label">Workflows</label>
        <p-multiSelect appendTo="body" filterPlaceHolder="Search"
          [options]="availableWorkflows"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="selectedWorkflowIds"
          placeholder="Select workflows"
          [panelStyle]="{ 'max-height': '300px', 'overflow': 'auto' }"
          styleClass="mapping-input">
        </p-multiSelect>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        label="Cancel"
        severity="secondary"
        (click)="closeDialog()">
      </p-button>

      <p-button
        label="Add"
        icon="pi pi-check"
        [disabled]="saving || !selectedWorkflowIds.length"
        (click)="confirmMapping()">
      </p-button>
    </ng-template>

  </p-dialog>

</div>
